// extracted by mini-css-extract-plugin
module.exports = {"Proposition":"jgp-1t9lC","Content":"jgp-2ifnK","Icon":"jgp-n-xV3","Message":"jgp-3XPN6"};